///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { DataResult } from '@progress/kendo-data-query';

export class ModelDataResult<T> implements DataResult {
    public data: T[];
    public total: number;
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/core/data/model-data-result.ts